const BestDeal = {
  id: "dela",
  title: "Best Deal",
  subtitle: "Best Deals summary and Setup",
  type: "group",
  icon: "heroicons-outline:shopping-cart",
  children: [
    {
      id: "pages.Notification",
      title: "Notification",
      type: "item",
      icon: "heroicons-outline:megaphone",
      url: "/documentation/changelog",
      badge: {
        title: "xxxx",
        bg: "rgb(236, 12, 142)",
        fg: "#FFFFFF",
      },
    },
    {
      id: "pages.activities",
      title: "Activities",
      type: "item",
      icon: "heroicons-outline:bars-3-bottom-left",
      url: "/pages/activities",
    },
    {
      id: "pages.ecommerce3",
      title: "Best Deals Design",
      type: "collapse",
      icon: "heroicons-outline:swatch",
      // translate: "ECOMMERCE",
      children: [
        {
          id: "e-commerce-category2",
          title: "Categories",
          type: "item",
          url: "/apps/best-deal/products",
          end: true,
        },
        {
          id: "e-commerce-products2",
          title: "Deals",
          type: "item",
          url: "/apps/best-deal/products",
          end: true,
        },
        {
          id: "e-commerce-product-detail2",
          title: "Deals Detail",
          type: "item",
          url: "/apps/best-deal/products/1/a-walk-amongst-friends-canvas-print",
        },
        {
          id: "e-commerce-new-product2",
          title: "New Deal Item",
          type: "item",
          url: "/apps/best-deal/products/new",
        },
      ],
    },
    {
      id: "pages.ecommerce2",
      title: "Orders",
      type: "collapse",
      icon: "heroicons-outline:truck",
      // translate: "ECOMMERCE",
      children: [
        {
          id: "e-commerce-orders2",
          title: "List of Orders",
          type: "item",
          url: "/apps/best-deal/orders",
          end: true,
        },
        {
          id: "e-commerce-order-detail2",
          title: "Order Detail",
          type: "item",
          url: "/apps/best-deal/orders/1",
        },
      ],
    },

    {
      id: "pages.coming-soon",
      title: "Coming Soon",
      type: "collapse",
      icon: "heroicons-outline:clock",
      url: "/pages/coming-soon",
      children: [
        {
          id: "pages.coming-soon.classic",
          title: "Classic",
          type: "item",
          url: "/pages/coming-soon/classic",
        },
        {
          id: "pages.coming-soon.modern",
          title: "Modern",
          type: "item",
          url: "/pages/coming-soon/modern",
        },
        {
          id: "pages.coming-soon.modern-reversed",
          title: "Modern Reversed",
          type: "item",
          url: "/pages/coming-soon/modern-reversed",
        },
        {
          id: "pages.coming-soon.split-screen",
          title: "Split Screen",
          type: "item",
          url: "/pages/coming-soon/split-screen",
        },
        {
          id: "pages.coming-soon.split-screen-reversed",
          title: "Split Screen Reversed",
          type: "item",
          url: "/pages/coming-soon/split-screen-reversed",
        },
        {
          id: "pages.coming-soon.full-screen",
          title: "Full Screen",
          type: "item",
          url: "/pages/coming-soon/full-screen",
        },
        {
          id: "pages.coming-soon.full-screen-reversed",
          title: "Full Screen Reversed",
          type: "item",
          url: "/pages/coming-soon/full-screen-reversed",
        },
      ],
    },

    {
      id: "pages.invoice",
      title: "Invoice",
      type: "collapse",
      icon: "heroicons-outline:calculator",
      children: [
        {
          id: "pages.invoice.printable",
          title: "Printable",
          type: "collapse",
          children: [
            {
              id: "pages.invoice.printable.compact",
              title: "Compact",
              type: "item",
              url: "/pages/invoice/printable/compact",
            },
            {
              id: "pages.invoice.printable.modern",
              title: "Modern",
              type: "item",
              url: "/pages/invoice/printable/modern",
            },
          ],
        },
      ],
    },
    {
      id: "pages.maintenance",
      title: "Maintenance",
      type: "item",
      icon: "heroicons-outline:exclamation-triangle",
      url: "/pages/maintenance",
    },
    {
      id: "pages.pricing",
      title: "Best deals forms",
      type: "collapse",
      icon: "heroicons-outline:bookmark-square",
      children: [
        {
          id: "pages.pricing.modern",
          title: "Modern",
          type: "item",
          url: "/pages/pricing/modern",
        },
        {
          id: "pages.pricing.simple",
          title: "Simple",
          type: "item",
          url: "/pages/pricing/simple",
        },
        {
          id: "pages.pricing.single",
          title: "Single",
          type: "item",
          url: "/pages/pricing/single",
        },
        {
          id: "pages.pricing.table",
          title: "Table",
          type: "item",
          url: "/pages/pricing/table",
        },
      ],
    },
    {
      id: "pages.search",
      title: "Help center",
      type: "collapse",
      icon: "heroicons-outline:light-bulb",
      children: [
        {
          id: "pages.search.classic-search",
          title: "FQAs",
          type: "item",
          url: "/pages/search/classic",
        },
        {
          id: "pages.search.modern-search",
          title: "Tutorial",
          type: "item",
          url: "/pages/search/modern",
        },
      ],
    },
  ],
};
export default BestDeal;
